import { NavController } from 'ionic-angular/navigation/nav-controller';
import { CoinsProvider } from './../../providers/coins/coins';
import { Coin, PriceFullRaw } from './../../models/Coin';
import { WatchlistProvider } from './../../providers/watchlist/watchlist';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

/**
 * Generated class for the WatchlistCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'watchlist-card',
  templateUrl: 'watchlist-card.html'
})
export class WatchlistCardComponent {
  coins: Coin[] = [];
  subscription: Subscription;
  showSpinner: boolean = true;
  length: number;
  constructor(
    public navCtrl: NavController,
    public watchCtrl: WatchlistProvider,
    public CP: CoinsProvider
  ) {
    this.subscription = this.watchCtrl.getWatchlistCoins().subscribe(coins => {
      //take top 3
      this.length = coins.length;
      let len = (this.length >= 3 ? 3 : this.length);
      for(let i = 0; i < len; i++){
        this.coins.push(coins[i]);
      }

      this.CP.addCoinsToMap(coins);
      this.showSpinner = false;
    }, error => {
      this.showSpinner = false;
      console.log(error);
    });
  }

  ngDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    this.CP.removeCoinsFromMap(this.coins);
  }

  getPrice(coin: Coin): PriceFullRaw{
    return this.CP.getPrice(coin);
  }

  goToWatchlist(){

  }

}



// WEBPACK FOOTER //
// ./src/components/watchlist-card/watchlist-card.ts